import React, { useContext } from 'react';
import { AgFinancingDocumentType, AgFinancingFile, AgFinancingMatricula, Phase2 } from '@indigo-ag/schema';

import { getAgFinancingMatriculas, getFilesForFinancing } from 'features/brazil-grower/queries';
import { FormattedMatriculasDetailData, MatriculasList } from '../MatriculasList/MatriculasList';
import { CARList } from '../CARList/CARList';
import { LoadingWrapper } from 'shared';
import { FinanceProcessContext } from 'features/brazil-grower/pages/BrazilGrowersDetail';

interface FieldMonitoringAnalysisProps {
  fieldMonitoringData: Phase2['fieldMonitoring'];
}

export const FieldMonitoringAnalysis: React.FunctionComponent<FieldMonitoringAnalysisProps> = ({
  fieldMonitoringData
}) => {
  /**
   * Context's
   */
  const { agFinancingId } = useContext(FinanceProcessContext);

  const renderMatriculasList = ({ data }: { data: { findAgFinancingMatriculas: AgFinancingMatricula[] } }) => {
    const matriculas: FormattedMatriculasDetailData[] = data?.findAgFinancingMatriculas?.map(matricula => {
      const detail = matricula.details?.find(d => !!d.id);
      return {
        id: matricula.id,
        detail,
        kml: matricula.kml || undefined,
        matricula: matricula.matricula,
        reports: matricula.fieldMonitoringFiles || []
      };
    });

    return <MatriculasList data={matriculas} fieldMonitoringData={fieldMonitoringData} />;
  };

  const renderCARList = ({ data }: { data: { financingAgFinancingFiles: AgFinancingFile[] } }) => {
    return <CARList carList={data.financingAgFinancingFiles} />;
  };

  return (
    <div>
      <LoadingWrapper
        query={getFilesForFinancing}
        queryOptions={{ variables: { params: { agFinancingId, documentType: [AgFinancingDocumentType.CAR] } } }}
      >
        {renderCARList}
      </LoadingWrapper>
      <LoadingWrapper query={getAgFinancingMatriculas} queryOptions={{ variables: { agFinancingId } }}>
        {renderMatriculasList}
      </LoadingWrapper>
    </div>
  );
};
